import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

import ButtonDisclosures from '../../../atoms/button-disclosures';
import CardModule from '../../shared/card-module';
import format from '../../../../utils/format';
import styles from './financial-strength-ratings.module.scss';
import { augmentClassName } from '../../../../utils/GlobalCssProxy';
import PropTypes from 'prop-types';

const className = augmentClassName(styles);

const FinancialStrengthRatings = ({ isPrinting }) => {
  return (
    <CardModule
      data-analytics-componenttype="half-width-component"
      data-analytics-id="HW_FinancialStrengthRatings"
      data-analytics-section="component"
      {...className('card-background')}
    >
      <CardModule.Header>Financial Strength Ratings</CardModule.Header>
      <CardModule.Body>
        <div {...className('paragraph-standard', 'mb-4')}>
          TIAA is one of only three insurance groups in the U.S. to currently
          hold the highest rating available from three of the four leading
          insurance company rating agencies.
        </div>
        <Row >
          <Col md={isPrinting ? 3 : 6} {...className('item-width', isPrinting ? '' : 'border-bottom', 'border-right', 'text-center', 'pb-5')}>
            <div {...className('rating', 'font-size-24', 'font-weight-bold')}>
              A++
            </div>
            <div {...className('font-size-16', 'mb-2')}>A.M. Best Company</div>
            <CardModule.AsOfDate>
              {format.date('2024-07-25')}
            </CardModule.AsOfDate>
          </Col>
          <Col md={isPrinting ? 3 : 6} {...className('item-width', isPrinting ? 'border-right' : 'border-bottom', 'text-center', 'pb-5')}>
            <div {...className('rating', 'font-size-24', 'font-weight-bold')}>
              AAA
            </div>
            <div {...className('font-size-16', 'mb-2')}>Fitch Ratings</div>
            <CardModule.AsOfDate>
              {format.date('2024-08-16')}
            </CardModule.AsOfDate>
          </Col>
          <Col md={isPrinting ? 3 : 6} {...className('item-width', 'border-right', 'text-center')}>
            <div {...className('rating', 'font-size-24', 'font-weight-bold')}>
              Aa1
            </div>
            <div {...className('font-size-16', 'mb-2')}>
              Moody&apos;s Investors Service
            </div>
            <CardModule.AsOfDate>
              {format.date('2024-10-15')}
            </CardModule.AsOfDate>
          </Col>
          <Col md={isPrinting ? 3 : 6} {...className('item-width', 'text-center')}>
            <div {...className('rating', 'font-size-24', 'font-weight-bold')}>
              AA+
            </div>
            <div {...className('font-size-16', 'mb-2')}>
              Standard & Poor&apos;s
            </div>
            <CardModule.AsOfDate>
              {format.date('2024-05-29')}
            </CardModule.AsOfDate>
          </Col>
        </Row>
      </CardModule.Body>
      <CardModule.Footer {...className('text-right')}>
        <ButtonDisclosures module={'financial-strength-ratings'} />
      </CardModule.Footer>
    </CardModule>
  );
};

FinancialStrengthRatings.propTypes = {
  isPrinting: PropTypes.bool
};

export default FinancialStrengthRatings;
